module.exports = __webpack_public_path__ + "static/media/Logo__Jetbrains.64b61fb6.svg";